var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import SearchTabs, { getSearchEnum } from "./SearchTabs";
import EdModalSearchBar from "@frameworks/web/components/generic/EdModalSearchBar";
import searchDi from "@mainDi/features/Search/servicelocator";
import debounce from "@frameworks/web/utils/debounce";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
import OptionChainToolBlock from "./OptionsChainTools";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
import { AssetTypeSwitch } from "./EquitySearchBlock";
import optionDi from "@frameworks/web/components/features/Markets/OptionChain/di/servicelocator";
import ComponentWithProvider from "@frameworks/shared-library/components/customHooks/ComponentWithProvider";
var SearchLayer = function (props) {
    var device = DeviceContext();
    var _a = __read(useState(), 2), searchList = _a[0], setSearchList = _a[1];
    var _b = __read(useState(), 2), searchKey = _b[0], setSearchKey = _b[1];
    var _c = __read(useState({ isOpen: false, error: null }), 2), error = _c[0], setError = _c[1];
    var _d = __read(useState(false), 2), loader = _d[0], setLoader = _d[1];
    var _e = __read(useState(false), 2), opt = _e[0], setOpt = _e[1];
    var _f = __read(useState(false), 2), openOption = _f[0], setOpenOption = _f[1];
    var _g = __read(useState(props.defaultActiveTab ? props.defaultActiveTab : "All"), 2), activeTab = _g[0], setActiveTab = _g[1];
    var _h = __read(useState(), 2), selectedOption = _h[0], setSelectedOptions = _h[1];
    var _j = __read(useState(false), 2), backState = _j[0], setBackState = _j[1];
    var _k = __read(useState(false), 2), assetFlag = _k[0], setAssetFlag = _k[1];
    var onSearch = function (search) {
        setSearchKey(search);
        if (!opt) {
            // setActiveTab("All");
            setOpenOption(false);
        }
        debounce(function () {
            if ((search === null || search === void 0 ? void 0 : search.length) > 2) {
                setSelectedOptions(undefined);
                setBackState(false);
                setError({ isOpen: false, error: undefined });
                if (activeTab === "All") {
                    setLoader(true);
                    searchDi.search
                        .getGeneralSearch({
                        searchText: search,
                    })
                        .then(function (data) {
                        var _a, _b, _c, _d, _e;
                        setSearchList(data.assetTypeGroup);
                        if (((_a = data.assetTypeGroup) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            var temp = data.assetTypeGroup;
                            if (activeTab !== "All") {
                                var active = temp.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === getSearchEnum(activeTab); })[0];
                                if (temp.indexOf(active) !== -1)
                                    temp.splice(temp.indexOf(active), 1);
                                if (!!active)
                                    temp.unshift(active);
                                else
                                    temp.unshift({
                                        assetType: getSearchEnum(activeTab),
                                        data: [],
                                    });
                            }
                            setSearchList(temp);
                        }
                        if (((_b = data === null || data === void 0 ? void 0 : data.assetTypeGroup) === null || _b === void 0 ? void 0 : _b.length) > 0 && !opt) {
                            if (((_c = data === null || data === void 0 ? void 0 : data.assetTypeGroup[0]) === null || _c === void 0 ? void 0 : _c.assetType) ===
                                SearchAssetTypeEnum.Option ||
                                ((_d = data === null || data === void 0 ? void 0 : data.assetTypeGroup[0]) === null || _d === void 0 ? void 0 : _d.assetType) ===
                                    SearchAssetTypeEnum.ComOpt ||
                                ((_e = data === null || data === void 0 ? void 0 : data.assetTypeGroup[0]) === null || _e === void 0 ? void 0 : _e.assetType) ===
                                    SearchAssetTypeEnum.CurOpt) {
                                setOpt(true);
                            }
                        }
                        setError(undefined);
                    })
                        .catch(function (error) {
                        setError({ isOpen: true, error: error });
                    })
                        .finally(function () { return setLoader(false); });
                }
                else {
                    if (getSearchEnum(activeTab) === SearchAssetTypeEnum.Option ||
                        getSearchEnum(activeTab) === SearchAssetTypeEnum.ComOpt ||
                        getSearchEnum(activeTab) === SearchAssetTypeEnum.CurOpt) {
                        setAssetFlag(true);
                        setOpt(true);
                    }
                    else {
                        setLoader(true);
                        searchDi.search
                            .getAssetTypeSearch(getSearchEnum(activeTab), {
                            searchText: search,
                            pageNumber: 1,
                            assetsFlag: "true",
                        })
                            .then(function (data) {
                            var _a, _b, _c, _d, _e;
                            var result;
                            if ((data === null || data === void 0 ? void 0 : data.generalResponse) &&
                                ((_b = (_a = data === null || data === void 0 ? void 0 : data.generalResponse) === null || _a === void 0 ? void 0 : _a.assetTypeGroup) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                                result = (_c = data === null || data === void 0 ? void 0 : data.generalResponse) === null || _c === void 0 ? void 0 : _c.assetTypeGroup;
                                result = (_e = (_d = data === null || data === void 0 ? void 0 : data.generalResponse) === null || _d === void 0 ? void 0 : _d.assetTypeGroup) === null || _e === void 0 ? void 0 : _e.map(function (e) {
                                    if ((e === null || e === void 0 ? void 0 : e.assetType) === getSearchEnum(activeTab))
                                        return __assign(__assign({}, e), { data: data[AssetTypeSwitch(getSearchEnum(activeTab))], nextPage: data === null || data === void 0 ? void 0 : data.nextPage, previousPage: data === null || data === void 0 ? void 0 : data.previousPage });
                                    else
                                        return __assign({}, e);
                                });
                                var active = result.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === getSearchEnum(activeTab); })[0];
                                if (result.indexOf(active) !== -1)
                                    result.splice(result.indexOf(active), 1);
                                if (!!active)
                                    result.unshift(active);
                                else
                                    result.unshift({
                                        assetType: getSearchEnum(activeTab),
                                        data: [],
                                    });
                            }
                            setSearchList(result);
                        })
                            .catch(function (error) {
                            setError({ isOpen: true, error: error });
                        })
                            .finally(function () { return setLoader(false); });
                    }
                }
            }
            else {
                setSearchList(undefined);
                setLoader(false);
            }
        }, 1000)();
        // }
    };
    useEffect(function () {
        optionDi.options.getBseNseExpiryDates();
    }, []);
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) && props.searchPopup && (React.createElement(EdModalSearchBar, { show: props.searchPopup, modalBodyContent: opt ? (React.createElement(OptionChainToolBlock, { setSearchList: setSearchList, searchKey: searchKey, setSearch: function (key) { return onSearch(key); }, setOptions: function (val) {
                setOpt(val);
                setOpenOption(!val);
            }, setSelectedOptions: setSelectedOptions, setSearchPopup: props.setSearchPopup, setActiveTab: setActiveTab, activeTab: activeTab, assetFlag: assetFlag })) : (React.createElement(SearchTabs, { setSearchData: setSearchList, backState: backState, searchData: searchList, loader: loader, error: error, setLoader: setLoader, search: searchKey, setSearch: setSearchKey, openOption: openOption, setOpt: setOpt, activeTab: activeTab, setActiveTab: setActiveTab, selectedOption: selectedOption, serachPopup: props.setSearchPopup, setShowToc: props.setShowToc, setSearchedQuote: props.setSearchData, hideTabs: props.hideTabs, placeOrder: props.placeOrder, cachingAtMiddleWare: true })), showFooter: false, footerContent: "", headContent: React.createElement(React.Fragment, null,
            React.createElement(SearchBar, { focusOnLoad: true, autoComplete: "oFF", openInputBackground: "bg_white", searchBarBackground: "bg_white rounded-0", iconColors: "txt-midnight-blue", parentClassName: "searchbar-search-block", onCallbackFunction: function (str) {
                    onSearch(str);
                }, deskPlaceHolder: props.placeholder, searchKey: searchKey, onClose: function () {
                    setOpt(false);
                    setOpenOption(false);
                    // setActiveTab("All");
                    setBackState(true);
                    setSearchKey("");
                    setSearchList(undefined);
                    setError({ isOpen: false, error: undefined });
                }, onBack: function () {
                    setOpt(false);
                    props.setSearchPopup(false);
                    setOpenOption(false);
                    setSearchKey("");
                    setSearchList(undefined);
                    setError({ isOpen: false, error: undefined });
                }, onBlur: function () {
                    // if (!searchKey) props.setSearchPopup(false);
                } })), setShow: props.setSearchPopup, customClass: props.sourceCustomClass }))));
};
var Search = function (props) {
    return React.createElement(ComponentWithProvider, { component: React.createElement(SearchLayer, __assign({}, props)) });
};
export default Search;
